import { useTranslation } from 'react-i18next'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import TrainingForm from '../common/TrainingForm'
import TrainingPlacowkaSection from '../common/TrainingPlacowkaSection'
import useTrainingEditPage from './hooks/useTrainingEditPage'

export default function TrainingEdit() {
	const { t } = useTranslation()
	const {
		certificationOptions,
		handleCancel,
		handleClearPlacowka,
		handleSubmit,
		loading,
		selectedPlacowka,
		setSelectedPlacowka,
		submitting,
		training,
		trainingNameOptions,
		contentOptions,
	} = useTrainingEditPage()

	if (loading) {
		return <LoadingIndicator message={t('trainings.edit.loading')} />
	}

	return (
		<div className="max-w-6xl mx-auto px-0 sm:px-6 lg:px-8">
			<div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
				<div className="px-4 sm:px-6 py-6 border-b border-gray-200">
					<h1 className="text-2xl font-bold text-gray-900">{t('trainings.edit.title')}</h1>
				</div>

				<div className="px-4 sm:px-6 py-6">
					<div className="space-y-6">
						<TrainingPlacowkaSection
							selectedPlacowka={selectedPlacowka}
							onSelectPlacowka={setSelectedPlacowka}
							onClearPlacowka={handleClearPlacowka}
							t={t}
						/>

						<TrainingForm
							mode="edit"
							initialData={training}
							certificationOptions={certificationOptions}
							trainingNameOptions={trainingNameOptions}
							contentOptions={contentOptions}
							onSubmit={handleSubmit}
							onCancel={handleCancel}
							submitting={submitting}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}
